import { Button } from '@/components'
import { RewardButtonWithState } from '@/components/molecules/rewards/RewardButton'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { PresentTypeBasedComponentsProps } from './presentTypeComponentType'

/**
 * PresentType 軸の/rewards/detail ページで使用されるコンポーネント
 * */
export const PresentType07GiftCodeComponents = ({
  selectedType,
  presentType,
  checkCondition,
  onStartDownload,
  onStartDownloadOnly,
  onStartDownloadWithLottery,
  onDecideUserPresentItem,
  onGoDirectToConfirm,
  buttonDisabled = false,
  isApplicationForm,
  userRewardState,
  presentItemList,
  isStock,
  inPeriod,
  userPresentItem,
}: PresentTypeBasedComponentsProps) => {
  const { t } = useTranslation()
  if (presentType !== 'GiftCode') {
    return null
  }
  if (!isStock) {
    const skipSpecificCondition1 = userRewardState === 'RECEIVED' || userRewardState === 'EXCHANGED'
    if (skipSpecificCondition1 && !presentItemList) {
      // skip: すぐに「終了しました」を出さない場合
    } else {
      return (
        <RewardButtonWithState
          inPeriod={inPeriod}
          isStock={isStock}
          checkCondition={checkCondition}
          selectedType={selectedType}
          presentType={presentType}
          isApplicationForm={isApplicationForm}
        />
      )
    }
  }

  if (!inPeriod) {
    return (
      <RewardButtonWithState
        inPeriod={inPeriod}
        isStock={isStock}
        checkCondition={checkCondition}
        selectedType={selectedType}
        presentType={presentType}
        isApplicationForm={isApplicationForm}
      />
    )
  }
  return (
    <>
      {selectedType === 1 && (
        <>
          {presentItemList ? (
            <>
              <Button
                text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
                width="w-9/12"
                disabled={buttonDisabled || !checkCondition}
                onClick={() => {
                  if (userRewardState === 'CONDITION_MET') {
                    onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId }))
                  }
                }}
              />
            </>
          ) : (
            <>
              <Button
                text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
                width="w-9/12"
                disabled={buttonDisabled || (userRewardState !== 'EXCHANGED' && !checkCondition)}
                onClick={() => {
                  if (userRewardState === 'CONDITION_MET') {
                    onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId }))
                  } else {
                    onGoDirectToConfirm({})
                  }
                }}
              />
            </>
          )}
        </>
      )}
      {selectedType === 2 && (
        <>
          {presentItemList ? (
            <Button
              text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
              width="w-9/12"
              disabled={buttonDisabled}
              onClick={onStartDownload}
            />
          ) : (
            <>
              <Button text={'存在しないパターン'} width="w-9/12" onClick={() => {}} disabled={true} />
            </>
          )}
        </>
      )}
      {selectedType === 3 && (
        <>
          {presentItemList ? (
            <>
              <Button
                text={
                  userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                    ? t('reward_detail.lottery', '抽選する')
                    : t('reward_detail.receive_your_prize_2', '賞品を受け取る')
                }
                width="w-9/12"
                disabled={buttonDisabled || !checkCondition}
                onClick={onStartDownloadWithLottery}
              />
            </>
          ) : (
            <>
              {userPresentItem?.user_presents?.length === 0 && (
                <>
                  <Button
                    text={t('reward_detail.lottery', '抽選する')}
                    width="w-9/12"
                    disabled={buttonDisabled || !checkCondition}
                    onClick={onStartDownloadWithLottery}
                  />
                </>
              )}
              {userPresentItem?.user_presents?.length === 1 && (
                <>
                  <Button
                    text={t('reward_detail.receive_your_prize_2', '賞品を受け取る')}
                    width="w-9/12"
                    disabled={
                      buttonDisabled ||
                      (userRewardState !== 'EXCHANGED' && !checkCondition) ||
                      userPresentItem?.user_presents[0]?.user_present_items[0]?.is_lost
                    }
                    onClick={userRewardState === 'RECEIVED' ? onStartDownload : onStartDownloadOnly}
                  />
                </>
              )}
              {userPresentItem?.user_presents?.length > 1 && (
                <>
                  <Button text={'存在しないパターン'} width="w-9/12" onClick={() => {}} disabled={true} />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
